<template>
  <div>
    <PageAllow
      controller="ProductionPlans"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card v-if="isNew">
        <v-card-title class="px-6 py-4">
          {{ $t("CRUD.newInfo", [$t("ProductionPlans.ObjectName")]) }}
          <v-chip
            v-if="production_plan.cancel_flg"
            small
            label
            outlined
            class="ms-4 mt-1"
            color="danger"
          >
            {{ $t("CRUD.cancelled") }}
          </v-chip>
          <v-spacer />
          <v-sheet class="pt-1 transparent-background-color d-inline-block">
            <!-- 返回 -->
            <v-btn
              v-if="(isNew && stockOutSelect && !next && !autoGenerate) || stockOutNext"
              small
              dark
              outlined
              color="secondary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="preview ? (preview = false) : (stockOutSelect = stockOutNext = false)"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.backForModify") }}
            </v-btn>
            <!-- 普通下一步按钮 -->
            <v-btn
              v-if="isNew && !next && !autoGenerate && !stockOutSelect && !stockOutNext"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="(isStockOutFlg) ? stockOutSelect = true : next = true"
            >
              {{ $t("ProductionPlans.actions.next") }}
            </v-btn>
            <!-- 按出库单生成下一步 -->
            <v-btn
              v-if="isNew && !next && !autoGenerate && stockOutSelect"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="checkStockOut()"
            >
              {{ $t("ProductionPlans.actions.next") }}
            </v-btn>
            <!-- 按出库单生成返回 -->
            <v-btn
              v-if="((isNew && next && !autoGenerate) || preview) && !stockOutSelect"
              small
              dark
              outlined
              color="secondary"
              class="px-2 me-2 mb-1 elevation-1"
              @click.stop="preview ? (preview = false) : (next = false)"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.backForModify") }}
            </v-btn>
            <!-- 提交 -->
            <v-btn
              v-if="(isNew && next) || mode == 'edit' || autoGenerate || stockOutNext"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1"
              @click.stop="(preview || stockOutNext) ? doSubmit() : doPreview()"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{
                action
                  ? action == "confirm"
                    ? $t("ProductionPlans.actions.confirmSubmit")
                    : action == "approve"
                    ? $t("ProductionPlans.actions.approveSubmit")
                    : $t("ProductionPlans.actions.editSubmit")
                  : $t("ProductionPlans.actions.editSubmit")
              }}
            </v-btn>
          </v-sheet>
        </v-card-title>
        <v-card-text class="px-6 pb-4">
          <v-divider />
          <span v-if="isNew && !next && !autoGenerate && !stockOutSelect && !stockOutNext">
            <v-row no-gutters class="mt-8">
              <span class="secondary--text" style="font-size: 16px">
                {{ $t("ProductionPlans.Fields.stock_name")
                }}{{ $t("Global.colon") }}
              </span>
              <v-autocomplete
                color="primary"
                hide-no-data
                v-model="stockSelected"
                :items="stocksItems"
                :loading="stockLoading"
                :search-input.sync="stockSearch"
                item-text="Description"
                item-value="id"
                return-object
                single-line
                dense
                hideDetails
                style="margin-left: auto; margin-right: auto"
              ></v-autocomplete>
            </v-row>
            <v-row no-gutters class="mt-8">
              <span class="secondary--text" style="font-size: 16px">
                {{ $t("ProductionPlans.Fields.type") }}{{ $t("Global.colon") }}
              </span>
              <v-radio-group
                row
                hide-details
                v-model="production_plan.production_type"
                class="d-inline-block mt-n1"
              >
                <v-radio
                  v-for="type in $consts.pruductionPlan.type"
                  :label="type.text"
                  :key="type.value"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <v-row no-gutters class="mt-6">
              <span class="secondary--text" style="font-size: 16px">
                {{ $t("ProductionPlans.Fields.is_stock_out_flg") }}{{ $t("Global.colon") }}
              </span>
              <v-checkbox
                color="primary"
                v-model="isStockOutFlg"
                :true-value="1"
                :false-value="0"
                class="d-inline-block mt-n1"
                @change="isStockOutFlg ? isFreeProduction = 0 : null;"
              >
            </v-checkbox>
            </v-row>
            <v-row no-gutters>
              <span class="secondary--text" style="font-size: 16px">
                {{ $t("ProductionPlans.Fields.is_free_production") }}{{ $t("Global.colon") }}
              </span>
              <v-checkbox
                color="primary"
                v-model="isFreeProduction"
                :true-value="1"
                :false-value="0"
                class="d-inline-block mt-n1"
                @change="isFreeProduction ? isStockOutFlg = 0 : null;"
              >
            </v-checkbox>
            </v-row>
          </span>
          <!-- 出库单生成选择出库单 -->
          <v-row
            v-else-if="isNew && stockOutSelect"
            class="mt-5"
          >
            <v-row dense class="mx-5">
              <v-col cols="12" sm="12" md="4">
                <v-row dense align="center" class="pa-1">
                  <SearcherDatetimeRangeWithRadio
                    v-model="stockOutOptions"
                    type="datetime"
                    show-radios
                    :radios="datetimeRadios"
                    deleteIcon
                    removeIcon
                  />
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="8" align-self="center">
                <v-row dense align="center" class="search-controls">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                        class="px-0 py-0 caption font-weight-bold grey--text"
                        color="primary"
                        @click.stop="onSearch()"
                      >
                        <v-icon small class="pe-1">fa-search</v-icon>
                        {{ $t("Search.search") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("Search.searchTip") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                        class="caption font-weight-bold grey--text"
                        @click.stop="resetSearch()"
                      >
                        <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                        {{ $t("Search.reset") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("Search.resetTip") }}</span>
                  </v-tooltip>
                  <v-divider vertical />
                  <v-btn
                    class="caption font-weight-bold grey--text"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                    small
                    text
                    @click.stop="$store.commit('toggleSearchPanel')"
                  >
                    {{ $t("Search.pro") }}
                    <v-icon small class="ps-1">{{
                        $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                      }}</v-icon>
                  </v-btn>
                  <v-spacer />
                </v-row>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="$store.getters.panels"
              multiple
              flat
              accordion
            >
              <v-expansion-panel class="transparent-background-color">
                <v-expansion-panel-content>
                  <v-row dense align="center">
                    <v-col cols="12" sm="6" md="4">
                      <SearcherStock v-model="stockSelected" unclearable :stockTypes="[0]" :productionAttribute="[1]" />
                    </v-col>
                    <!-- 客户 -->
                    <v-col cols="12" sm="6" md="4">
                      <SearcherShops v-model="shopsSelected" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <SearcherMaterials v-model="materialSelected" :productionAttribute="[1]" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <SearcherStatus
                        v-model="isStockCurrent"
                        :items="[
                          {
                            text: $t('PurchasePlans.isStockCurrent'),
                            color: 'primary',
                            textColor: 'white',
                            value: 1,
                          },
                        ]"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="mx-4 my-4" style="width: 100%">
              <v-data-table
                v-model="stockOutSelected"
                id="purchase_from_order_table"
                :headers="stockOutHeaders"
                class="elevation-2 pa-4 mt-4"
                :items="stockOuts"
                show-select
                item-key="id"
                disable-sort
                :options.sync="stockOutOptions"
                :page.sync="stockOutPaging.page"
                :server-items-length="stockOutPaging.count"
                :footer-props="footerProps"
                :loading="stockOutLoading"
              >
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
              </v-data-table>
            </div>
          </v-row>
          <!-- 普通明细 表头 -->
          <v-row
            v-if="isNew && (next || autoGenerate || stockOutNext)"
            no-gutters
            class="mt-4 table-style"
            style="font-size: 16px"
          >
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("ProductionPlans.Fields.stock_name")
                  }}{{ $t("Global.colon") }}
                </span>
                {{
                  isNew
                    ? stockSelected.name
                    : production_plan.stock
                    ? production_plan.stock.name
                    : ""
                }}
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("ProductionPlans.Fields.type")
                  }}{{ $t("Global.colon") }}
                </span>
                {{ production_plan.production_type | productionPlansTypeText }}
              </v-card>
            </v-col>
            <v-col cols="12" md="12">
              <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                <span class="secondary--text">
                  {{ $t("ProductionPlans.Fields.memo")}}{{ $t("Global.colon") }}
                </span>
                <v-text-field
                  v-if="isNew && savable"
                  v-model="memo"
                  single-line
                  dense
                  hide-details
                  class="d-inline mt-0 mb-n1"
                />
                <span v-else>
                  {{ memo }}
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-expansion-panels v-model="panels" multiple accordion v-else>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("ProductionPlans.ObjectName")]) }}
              <v-chip
                v-if="production_plan.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="production_plan.status | productionPlansStatusColor"
                :text-color="
                  production_plan.status | productionPlansStatusTextColor
                "
                >{{ production_plan.status | productionPlansStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="(isNew && next && !autoGenerate) || preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="preview ? (preview = false) : (next = false)"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="(isNew && next) || mode == 'edit' || autoGenerate"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{
                    action
                      ? action == "confirm"
                        ? $t("ProductionPlans.actions.confirmSubmit")
                        : action == "approve"
                        ? $t("ProductionPlans.actions.approveSubmit")
                        : $t("ProductionPlans.actions.editSubmit")
                      : $t("ProductionPlans.actions.editSubmit")
                  }}
                </v-btn>
              </v-sheet>

              <ProductionPlanActions
                v-if="isView"
                :production_plan="production_plan"
                :showEdit="
                  production_plan.actions
                    ? production_plan.actions.account_edit
                    : false
                "
                @edit="mode = 'edit'"
                :showConfirm="
                  production_plan.actions
                    ? production_plan.actions.confirm
                    : false
                "
                @confirm="
                  mode = 'edit';
                  action = 'confirm';
                "
                :showApprove="
                  production_plan.actions
                    ? production_plan.actions.approve
                    : false
                "
                @approve="
                  mode = 'edit';
                  action = 'approve';
                "
                :showStockIN="
                  production_plan.actions ? production_plan.actions.in : false
                "
                :showStockOUT="
                  production_plan.actions ? production_plan.actions.out : false
                "
                detail-mode
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style" style="font-size: 16px">
              <v-col cols="12" md="4" v-if="mode == 'edit' || isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.production_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.stock_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    isNew
                      ? stockSelected.name
                      : production_plan.stock
                      ? production_plan.stock.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.type")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    production_plan.production_type | productionPlansTypeText
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.status")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.status | productionPlansStatusText }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    production_plan.creater ? production_plan.creater.name : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ production_plan.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ProductionPlans.Fields.memo")}}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ memo }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("ProductionPlans.actions.activities") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("ProductionPlans.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="production_plan_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="production_plan_relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>

                    <template v-slot:item.identify_name="{ item }">
                      <span v-if="!item.index" class="text-no-wrap">
                        {{ item.identify_name }}
                      </span>
                    </template>
                    <template v-slot:item.identify_code="{ item }">
                      <span class="text-no-wrap">
                        {{ item.identify_code }}
                      </span>
                      <br />
                      <span v-if="item.stock">
                        {{ item.stock.name }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status >= 0" class="text-no-wrap">
                        <v-chip
                          v-if="item.identify == 'production-stock-out'"
                          small
                          label
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                          >{{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'production-stock-in'"
                          small
                          label
                          :color="item.status | stockOrderINStatusColor"
                          :text-color="
                            item.status | stockOrderINStatusTextColor
                          "
                          >{{ item.status | stockOrderINStatusText }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="
                          $permission.permissionAllow(item.controller, 'view')
                        "
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="'/#/' + item.identify + '/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card v-if="showDetailTable" class="px-4 mt-4">
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-data-iterator
              :items="production_plan_details"
              :items-per-page.sync="production_plan_details.length"
              hide-default-footer
              class="py-5"
              no-data-text=""
            >
              <template v-slot:header>
                <v-toolbar flat class="transparent-background-color">
                  <v-toolbar-title class="ms-n2">
                    {{ $t("CRUD.details", [$t("ProductionPlans.ObjectName")]) }}
                  </v-toolbar-title>
                  <span class="caption secondary--text pt-2 ms-3">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        production_plan_details
                          ? [
                              1,
                              production_plan_details.length,
                              production_plan_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                </v-toolbar>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                  v-if="savable && !autoGenerate && !stockOutNext"
                >
                  <v-row align="center">
                    <keep-alive>
                      <v-autocomplete
                        color="primary"
                        v-model="productionMaterialSelected"
                        :items="production_materials"
                        :loading="productionMaterialLoading"
                        :search-input.sync="productionMaterialSearch"
                        item-value="id"
                        item-text="material_name"
                        item-disabled="disabled"
                        :label="$t('Material.ObjectName')"
                        return-object
                        style="margin-left: auto; margin-right: auto"
                        single-line
                        dense
                        hide-details
                        clearable
                      >
                      </v-autocomplete>
                    </keep-alive>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:default="{ items }">
                <v-card class="mt-2" v-for="(item, index) in items" :key="index">
                  <v-row class="ma-1">
                    <v-col> </v-col>
                    <v-card-title class="me-3">
                      <v-tooltip left class="me-1" v-if="savable && item.new">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="danger--text pa-0"
                            @click="removeDetail(item)"
                            >fa-times
                          </v-icon>
                        </template>
                        <span>
                          {{ $t("ProductionPlans.actions.remove_detail") }}
                        </span>
                      </v-tooltip>
                    </v-card-title>
                  </v-row>
                  <v-divider />

                  <v-row class="ma-1">
                    <v-col
                      cols="12"
                      :md="production_plan.production_type === 1 ? '3' : '4'"
                      v-if="!isFreeProduction"
                    >
                      <v-row v-if="savable && item.new">
                        <v-col cols="8">
                          <v-select
                            v-if="savable && item.new"
                            v-model="item.formulaSelected"
                            :items="item.formulaDetails"
                            item-text="name"
                            item-value="uuid"
                            single-line
                            dense
                            hideDetails
                            class="mt-n1"
                            style="margin-left: auto; margin-right: auto"
                            return-object
                            @change="updateProductionNum(0, item, true)"
                          />
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                            v-if="
                              $permission.permissionAllow(
                                'ProductionPlans',
                                'editMaterialFormula'
                              ) && production_plan.production_type == 1
                            "
                            color="primary"
                            small
                            class="pa-1"
                            @click="
                              currentCombineFormula = item.formulaSelected;
                              currentMaterial = item;
                              productionCombineFormulaDialog = true;
                            "
                            >{{
                              $t(
                                "ProductionPlans.DetailFields.editMaterialFormula"
                              )
                            }}</v-btn
                          >
                          <v-btn
                            v-if="
                              $permission.permissionAllow(
                                'ProductionPlans',
                                'editMaterialFormula'
                              ) && production_plan.production_type == 2
                            "
                            color="primary"
                            small
                            class="pa-1"
                            @click="
                              currentSplitFormula = item.formulaSelected;
                              currentMaterial = item;
                              productionSplitFormulaDialog = true;
                            "
                            >{{
                              $t(
                                "ProductionPlans.DetailFields.editMaterialFormula"
                              )
                            }}</v-btn
                          >
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        {{ item.formula_name }}
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-simple-table fixed-header class="ma-1 pb-2">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            <span
                              v-if="production_plan.production_type == 2"
                              style="background: #ffff00"
                            >
                              {{
                                $t(
                                  "ProductionPlans.DetailFields.split_material"
                                )
                              }}
                            </span>
                            <span v-else style="background: #00ff00">
                              {{
                                $t(
                                  "ProductionPlans.DetailFields.combined_material"
                                )
                              }}
                            </span>
                          </th>
                          <th class="text-center">
                            {{
                              $t(
                                "ProductionPlans.DetailFields.current_stock_count"
                              )
                            }}
                          </th>
                          <th class="text-center">
                            {{
                              production_plan.production_type == 2
                                ? $t(
                                    "ProductionPlans.DetailFields.split_material_num"
                                  )
                                : $t(
                                    "ProductionPlans.DetailFields.combined_material_num"
                                  )
                            }}
                          </th>
                          <th
                            class="text-center"
                            v-if="production_plan.production_type == 1"
                          >
                            {{ $t("ProductionPlans.DetailFields.price") }}
                          </th>
                          <th class="text-center">
                            {{ $t("ProductionPlans.DetailFields.other_cost") }}
                          </th>
                          <th class="text-center">
                            <span
                              v-if="production_plan.production_type == 2"
                              style="background: #00ff00"
                            >
                              {{
                                $t(
                                  "ProductionPlans.DetailFields.splitFormulaMaterial"
                                )
                              }}
                            </span>
                            <span v-else style="background: #ffff00">
                              {{
                                $t(
                                  "ProductionPlans.DetailFields.combinedFormulaMaterial"
                                )
                              }}
                            </span>
                          </th>
                          <th class="text-center">
                            {{ $t("ProductionPlans.DetailFields.changed_num") }}
                          </th>
                          <th
                            v-if="production_plan.production_type == 2"
                            class="text-center"
                          >
                            {{ $t("ProductionPlans.DetailFields.price") }}
                          </th>
                          <th class="text-right">
                            {{
                              $t("ProductionPlans.DetailFields.average_price")
                            }}
                          </th>
                          <th class="text-right">
                            {{ $t("ProductionPlans.DetailFields.stock_num") }}
                          </th>
                          <th class="text-right">
                            {{ $t("ProductionPlans.DetailFields.memo") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="!isFreeProduction">
                        <tr
                          v-for="(formula_detail, i) in item.new
                            ? item.formulaSelected.formula_details
                            : item.formula_details"
                          :key="formula_detail.material_id"
                        >
                          <td class="text-left">
                            <span v-if="i == 0">
                              <span>{{ item.material_name }}</span>
                              <br />
                              <span class="caption secondary--text">
                                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                                  {{ item.standard_name.slice(0, 12) + "......" }}
                                </span>
                                <span v-else>
                                  {{ item.standard_name }}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-center">
                            <span v-if="i == 0">
                              {{ item.current_count | formatTwoDot }}
                              {{ item.unit }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-inline-block" v-if="i == 0">
                              <NumberInput
                                v-if="
                                  savable &&
                                  production_plan.production_type == 1
                                "
                                v-model="item.production_num"
                                dense
                                @blur.native.capture="
                                  updateProductionNum(
                                    item.material_id,
                                    item,
                                    true
                                  )
                                "
                              >
                                <template v-slot:append>
                                  {{ item.unit }}
                                </template>
                              </NumberInput>
                              <ValidationProvider
                                v-else-if="
                                  savable &&
                                  production_plan.production_type == 2
                                "
                                v-slot="{ errors }"
                                :rules="production_plan.inventory_check_flg == 1 ? {max_value: item.current_count} : ''"
                              >
                                <NumberInput
                                  v-model="item.production_num"
                                  :error-messages="errors"
                                  dense
                                  @blur.native.capture="
                                    updateProductionNum(
                                      item.material_id,
                                      item,
                                      true
                                    )
                                  "
                                >
                                  <template v-slot:append>
                                    {{ item.unit }}
                                  </template>
                                </NumberInput>
                              </ValidationProvider>
                              <span v-else>
                                {{ item.production_num | formatTwoDot }}
                                {{ item.unit }}
                              </span>
                            </div>
                          </td>
                          <td
                            class="text-center"
                            v-if="production_plan.production_type == 1"
                          >
                            {{
                              i == 0
                                ? $t(
                                    "PurchasesDetail.purchaseFields.produciton_in_price"
                                  )
                                : ""
                            }}
                          </td>

                          <td class="text-center">
                            <div class="d-inline-block" v-if="i == 0">
                              <v-text-field
                                v-if="savable"
                                v-model="item.other_cost"
                                single-line
                                dense
                                hide-details
                                type="number"
                                min="0"
                                :prefix="$t('Global.money')"
                                @blur="
                                  item.other_cost =
                                    $numberFormatter.formatMoney(
                                      item.other_cost
                                    )
                                "
                                style="max-width: 80px; margin-left: auto"
                              />
                              <span v-else>
                                {{ $t("Global.money") }}
                                {{ item.other_cost | formatTwoDot }}
                              </span>
                            </div>
                          </td>
                          <td class="text-center">
                            {{ formula_detail.material_name }}
                          </td>
                          <td class="text-center">
                            <ValidationProvider
                              v-if="
                                savable && production_plan.production_type == 1
                              "
                              v-slot="{ errors }"
                              :rules="production_plan.inventory_check_flg == 1 ? {max_value: formula_detail.current_count}: ''"
                            >
                              <NumberInput
                                v-model="formula_detail.production_num"
                                :error-messages="errors"
                                dense
                                @blur.native.capture="
                                  updateProductionNum(
                                    formula_detail.material_id,
                                    item,
                                    false
                                  )
                                "
                              >
                                <template v-slot:append>
                                  {{ formula_detail.unit }}
                                </template>
                              </NumberInput>
                            </ValidationProvider>
                            <NumberInput
                              v-else-if="
                                savable && production_plan.production_type == 2
                              "
                              v-model="formula_detail.production_num"
                              dense
                              @blur.native.capture="
                                updateProductionNum(
                                  formula_detail.material_id,
                                  item,
                                  false
                                )
                              "
                            >
                              <template v-slot:append>
                                {{ formula_detail.unit }}
                              </template>
                            </NumberInput>
                            <span v-else>
                              {{ formula_detail.production_num }}
                              {{ formula_detail.unit }}
                            </span>
                          </td>
                          <td
                            v-if="production_plan.production_type == 2"
                            class="text-center"
                          >
                            <!-- <v-text-field
                              v-if="savable"
                              v-model="formula_detail.in_price"
                              single-line
                              dense
                              hide-details
                              type="number"
                              min="0"
                              :prefix="$t('Global.money')"
                              @blur="
                                $numberFormatter.formatWithDotNoMoreThan(
                                  formula_detail.in_price,
                                  2
                                )
                              "
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") }}
                              {{ formula_detail.in_price }}
                            </span> -->
                            {{
                              (settings && settings.production_in_price_setting == 1)
                                ? $t(
                                    "BusinessSetting.StockManagementSetting.production_in_price_types.produciton_in_price"
                                  )
                                : $t(
                                    "BusinessSetting.StockManagementSetting.production_in_price_types.other_cost_price"
                                  )
                            }}
                          </td>
                          <td class="text-right">
                            {{ $t("Global.money") }}
                            {{ formula_detail.average_price | formatTwoDot }}
                          </td>
                          <td class="text-right">
                            {{ formula_detail.current_count | formatTwoDot }}
                            {{ formula_detail.unit }}
                          </td>
                          <td class="text-center">
                            <span v-if="i == 0">
                              <v-text-field
                                v-if="savable"
                                v-model="item.memo"
                                single-line
                                dense
                                hide-details
                                style="max-width: 120px"
                              >
                              </v-text-field>
                              <span v-else>
                                {{ item.memo }}
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <!-- 自由生产表格 -->
                      <tbody v-else>
                      <tr>
                        <td class="text-left">
                          <span>
                            <span>{{ item.material_name }}</span>
                            <br />
                            <span class="caption secondary--text">
                              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                                {{ item.standard_name.slice(0, 12) + "......" }}
                              </span>
                              <span v-else>
                                {{ item.standard_name }}
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="text-center">
                          <span>
                            {{ item.current_count | formatTwoDot }}
                            {{ item.unit }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="d-inline-block">
                            <NumberInput
                              v-if="savable"
                              v-model="item.production_num"
                              dense
                            >
                              <template v-slot:append>
                                {{ item.unit }}
                              </template>
                            </NumberInput>
                            <span v-else>
                              {{ item.production_num | formatTwoDot }}
                              {{ item.unit }}
                            </span>
                          </div>
                        </td>
                        <td
                          class="text-center"
                          v-if="production_plan.production_type == 1"
                        >
                          {{ $t("PurchasesDetail.purchaseFields.produciton_in_price") }}
                        </td>
                        <td class="text-center">
                          <div class="d-inline-block">
                            <v-text-field
                              v-if="savable"
                              v-model="item.other_cost"
                              single-line
                              dense
                              hide-details
                              type="number"
                              min="0"
                              :prefix="$t('Global.money')"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") }}
                              {{ item.other_cost | formatTwoDot }}
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <v-autocomplete
                            v-if="savable && item.new"
                            color="primary"
                            v-model="freeProductionMaterialSelected"
                            :items="productionMaterialItems(item)"
                            :loading="productionMaterialLoading"
                            item-value="id"
                            item-text="material_name"
                            item-disabled="disabled"
                            :label="$t('Material.ObjectName')"
                            return-object
                            style="margin-left: auto; margin-right: auto"
                            single-line
                            dense
                            hide-details
                            clearable
                            @change="addFreeProduction(item, index)"
                          >
                          </v-autocomplete>
                        </td>
                        <td class="text-center"></td>
                        <td class="text-center" v-if="production_plan.production_type == 2"></td>
                        <td class="text-right"></td>
                        <td class="text-right"></td>
                        <td class="text-center">
                          <span>
                            <v-text-field
                              v-if="savable"
                              v-model="item.memo"
                              single-line
                              dense
                              hide-details
                              style="max-width: 120px"
                            >
                            </v-text-field>
                            <span v-else>
                              {{ item.memo }}
                            </span>
                          </span>
                        </td>
                      </tr>
                      <tr
                        v-for="(formula_detail, i) in item.formula_details"
                        :key="i"
                      >
                        <td class="text-left"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center" v-if="production_plan.production_type == 1"></td>
                        <td class="text-center">
                          <span>
                            {{ formula_detail.material_name }}
                          </span>
                          <br />
                          <span class="caption secondary--text">
                              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                              <span v-if="formula_detail.standard_name && formula_detail.standard_name.length > 12" :title="formula_detail.standard_name" style="cursor: pointer">
                                {{ formula_detail.standard_name.slice(0, 12) + "......" }}
                              </span>
                              <span v-else>
                                {{ formula_detail.standard_name }}
                              </span>
                            </span>
                        </td>
                        <td class="text-center">
                          <NumberInput
                              v-if="savable"
                              v-model="formula_detail.production_num"
                              dense
                          >
                            <template v-slot:append>
                              {{ formula_detail.unit }}
                            </template>
                          </NumberInput>
                          <span v-else>
                            {{ formula_detail.production_num }}
                            {{ formula_detail.unit }}
                          </span>
                        </td>
                        <td
                            v-if="production_plan.production_type == 2"
                            class="text-center"
                        >
                          {{
                            (settings && settings.production_in_price_setting == 1)
                                ? $t(
                                    "BusinessSetting.StockManagementSetting.production_in_price_types.produciton_in_price"
                                )
                                : $t(
                                    "BusinessSetting.StockManagementSetting.production_in_price_types.other_cost_price"
                                )
                          }}
                        </td>
                        <td class="text-right">
                          {{ $t("Global.money") }}
                          {{ formula_detail.average_price | formatTwoDot }}
                        </td>
                        <td class="text-right">
                          {{ formula_detail.current_count | formatTwoDot }}
                          {{ formula_detail.unit }}
                        </td>
                        <td class="text-center"></td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </template>
            </v-data-iterator>
          </v-container>
        </ValidationObserver>
      </v-card>
    </v-sheet>
    <Formula
      v-model="currentCombineFormula"
      combine
      :show="productionCombineFormulaDialog"
      :defaultUnit="
        currentMaterial
          ? currentMaterial.standard
            ? currentMaterial.standard.default_standard_detail
              ? currentMaterial.standard.default_standard_detail.unit
              : ''
            : ''
          : ''
      "
      :materialName="currentMaterial.material_name"
      @confirm="formulaSubmit($event)"
      @close="productionCombineFormulaDialog = false"
    />
    <Formula
      v-model="currentSplitFormula"
      split
      :show="productionSplitFormulaDialog"
      :defaultUnit="
        currentMaterial
          ? currentMaterial.standard
            ? currentMaterial.standard.default_standard_detail
              ? currentMaterial.standard.default_standard_detail.unit
              : ''
            : ''
          : ''
      "
      :materialName="currentMaterial.material_name"
      @confirm="formulaSubmit($event)"
      @close="productionSplitFormulaDialog = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Stocks from "@/api/stocks";
import ProductionPlans from "@/api/production_plans";
import ProductionPlanActions from "./plugins/Actions";
import NumberInput from "@/components/plugins/NumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Formula from "./plugins/Formula";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStock from "@/components/plugins/SearcherStock.vue";
import SearcherShops from "@/components/plugins/SearcherShops.vue";
import SearcherMaterials from "@/components/plugins/SearcherMaterials.vue";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import StockOuts from "@/api/stock_outs";
import StockMaterials from "@/api/stock_materials";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
      new Date(new Date().getTime())
          .toISOString()
          .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  order_time_from: "",
  order_time_to: "",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  stock_ids: [],
  shop_ids: [],
  material_ids: [],
  type: [1],
  is_produced: [0],
  status: [2],
  production_attribute_flgs: [1],
};


export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ProductionPlanActions,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
    Formula,
    SearcherDatetimeRangeWithRadio,
    SearcherMaterials,
    SearcherShops,
    SearcherStock,
    SearcherStatus,
  },

  computed: {
    stock_id() {
      return this.isNew
        ? this.stockSelected
          ? this.stockSelected.id
          : null
        : this.production_plan
        ? this.production_plan.stock
          ? this.production_plan.stock.id
          : null
        : null;
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return !this.preview && (this.mode == "new" || this.mode == "edit");
    },
    isNew() {
      return this.mode == "new";
    },
    showDetailTable() {
      return (
        (this.mode == "new" && this.next) ||
        (this.mode == "new" && this.autoGenerate) ||
        (this.mode == "new" && this.stockOutNext) ||
        this.mode == "edit" ||
        this.preview ||
        this.isView
      );
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ProductionPlans.Fields.created_time"),
      },
      {
        key: "order",
        text: i18n.t("ProductionPlans.Fields.order_time"),
      },
      {
        key: "actual",
        text: i18n.t("ProductionPlans.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("ProductionPlans.Fields.expect_time"),
      },
    ],
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.productionManagement"),
          disabled: false,
          replace: true,
          href: "/production-plans",
        },
        {
          text: i18n.t("Nav.productionPlans"),
          disabled: false,
          href: "/production-plans",
        },
        {
          text:
            this.mode == "confirm"
              ? i18n.t("Nav.orderConfirm")
              : this.mode == "approve"
              ? i18n.t("Nav.orderApprove")
              : this.isNew
              ? i18n.t("Nav.productionPlanNew")
              : i18n.t("Nav.productionPlanDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.production_plan && this.production_plan.stock_order_code
              ? this.production_plan.stock_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("ProductionPlans.DetailFields.material_name"),
          align: "center",
          value: "Description",
        },
        {
          text: i18n.t("ProductionPlans.DetailFields.changed_num"),
          align: "start",
          value: "changed_num",
        },
      ];

      if (this.production_plan.production_type == 2) {
        headers.push({
          text: i18n.t("ProductionPlans.DetailFields.price"),
          align: "center",
          value: "price",
        });
      }

      headers.push(
        {
          text: i18n.t("ProductionPlans.DetailFields.average_price"),
          align: "center",
          value: "average_price",
        },
        {
          text: i18n.t("ProductionPlans.DetailFields.stock_num"),
          align: "center",
          value: "stock_num",
        }
      );
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ProductionPlans.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ProductionPlans.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ProductionPlans.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("ProductionPlans.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("ProductionPlans.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    stockOutHeaders() {
      let headers = [
        {
          text: i18n.t("PurchasePlans.Fields.stock_out_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("PurchasePlans.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("PurchasePlans.Fields.out_type_str"),
          align: "start",
          value: "out_type_str",
        },
        {
          text: i18n.t("PurchasePlans.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("PurchasePlans.Fields.created"),
          align: "start",
          value: "created",
        },
      ];
      return headers;
    },

    stocksItems() {
      return this.stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        return Object.assign({}, stock, { Description });
      });
    },
    footerProps() {
      let props = i18n.t("$config.footer-props");
      props.itemsPerPageOptions.push(-1);
      return props;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    action: "",
    production_plan: {},
    production_plan_details: [],
    production_plan_activities: [],
    stocks: [],
    stockLoading: false,
    stockSearch: "",
    stockSelected: null,
    next: false,
    autoGenerate: false,
    production_materials: [],
    productionMaterialLoading: false,
    productionMaterialSearch: "",
    productionMaterialSelected: null,
    freeProductionMaterialSelected: null,
    formulaSelected: null,
    preview: false,
    production_plan_relations: [],
    productionCombineFormulaDialog: false,
    productionSplitFormulaDialog: false,
    currentCombineFormula: {},
    currentSplitFormula: {},
    currentMaterial: {},
    memo: "",
    isStockOutFlg: 0,
    isFreeProduction: 0,
    stockOutSelect: false,
    stockOutNext: false,
    stockOutOptions: JSON.parse(JSON.stringify(defaultOptions)),
    shopsSelected: [],
    materialSelected: [],
    stockOutSelected: [],
    isStockCurrent: [],
    stockOuts: [],
    stockOutPaging: {},
    stockOutLoading: false,

  }),

  mounted() {
    if (this.$route.path.startsWith("/production-plans/new")) {
      this.mode = "new";
      //判断是否是智能拆零
      if (this.$route.query.stock && this.$route.query.showSelected) {
        this.autoGenerate = true;
        var stock_in_detail_ids = JSON.parse(
          decodeURIComponent(this.$route.query.showSelected)
        );
        this.stockSelected = JSON.parse(
          decodeURIComponent(this.$route.query.stock)
        );

        //获取智能拆零详情
        ProductionPlans.addAutoSplitProduction({
          stock_id: this.stockSelected.id,
          stock_in_details: stock_in_detail_ids,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              var production_materials = Object.values(
                response.data.production_materials
              );
              production_materials.forEach((material) => {
                var formulaDetails = Object.values(material.formula);
                formulaDetails.forEach((formula) => {
                  formula.formula_details.forEach((detail) => {
                    detail.production_num =
                      material.production_num * detail.ratio;
                    detail.in_price = 0;
                  });
                });

                this.production_plan_details.push(
                  Object.assign(material, {
                    new: this.production_plan_details.length + 1,
                    production_num: material.production_num,
                    formulaDetails: formulaDetails,
                    formulaSelected:
                      material.formula[material.formula_default_key],
                  })
                );
              });
            }
          }.bind(this)
        );
      }
    } else {
      this.mode = this.$route.params.mode;
      this.action = this.$route.params.action;
      if (this.mode) {
        if (this.action) {
          this.$router.replace(
            "/production-plans/" + this.$route.params.id + "/" + this.action
          );
        } else {
          this.$router.replace("/production-plans/" + this.$route.params.id);
        }
      }
    }

    //获取仓库列表
    Stocks.fetchAllForSelect({ production_attribute: [1], status: [1] })
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
            if (!this.stockSelected) {
              this.stockSelected = this.stocks[0];
            }
          }
          this.stockLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.stockLoading = false;
        }.bind(this)
      );
  },

  methods: {
    //获取商品列表
    getProductionMaterialsFromAPI() {
      ProductionPlans.getProductionMaterials({
        stock_id: this.stock_id,
        production_type: this.production_plan.production_type,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var materials = response.data.materials;
            this.production_materials = Object.values(materials).map((item) => {
              const disabled =
                this.production_plan_details &&
                this.production_plan_details.find(
                  (detail) => detail.material_id == item.id
                )
                  ? true
                  : item.disabled
                  ? true
                  : false;
              return Object.assign({}, item, { disabled });
            });
          }
        }.bind(this)
      );
    },
    // 自由生产获取商品
    getStockMaterialsFromAPI() {
      this.$store.dispatch("fullscreenLoading");
      let postData = {
        stock_id: this.stock_id,
        status: [1],
        material_delete_flg: [0]
      }

      let fieldFilter = [
        // "id",
        // "stock_id",
        // "unit",
        // "StockMaterials.material_id",
        // "standard_detail_id",
        // "total_price",
        // "stock_min",
        // "stock_max",
        // "Material.material_code",
        // "Material.material_name",
        // "MaterialCategory.name",
        // "stock_num",
      ];
      postData = Object.assign(
          {
            fieldFilter: fieldFilter,
            // 仅筛选少许必要字段
          },
          postData
      );

      StockMaterials.getSimpleStockMaterials(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.production_materials = Object.values(response.data.stock_materials)
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
          );
    },
    // 获取单据详情
    getProductionPlanFromAPI() {
      ProductionPlans.fetchOne(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.production_plan = response.data.production_plan;
            if (response.data.production_plan.business_type == 3) {
              this.isFreeProduction = 1
              this.stock_id = response.data.production_plan.stock_id
              this.getStockMaterialsFromAPI()
            }
            this.memo = this.production_plan.memo

            this.production_plan_details =
              response.data.production_plan.production_plan_history_details;
            this.production_plan_activities = response.data.order_activities;
            this.production_plan_relations = [];
            if (response.data.production_plan.stock_out) {
              this.production_plan_relations.push(
                Object.assign(
                  {
                    controller: "StockOuts",
                    identify: "production-stock-out",
                    identify_name: i18n.t("StockOrderOUT.ObjectName"),
                    identify_code:
                      response.data.production_plan.stock_out.stock_order_code,
                  },
                  response.data.production_plan.stock_out
                )
              );
            }
            if (
              response.data.production_plan.stock_in &&
              this.production_plan.status >= 4
            ) {
              // 生产入库单到待入库的状态以后才会显示
              this.production_plan_relations.push(
                Object.assign(
                  {
                    controller: "StockIns",
                    identify: "production-stock-in",
                    identify_name: i18n.t("StockOrderIN.ObjectName"),
                    identify_code:
                      response.data.production_plan.stock_in.stock_order_code,
                  },
                  response.data.production_plan.stock_in
                )
              );
            }
          }
        }.bind(this)
      );
    },
    // 主数据和子数据的数量联动
    updateProductionNum(material_id, production, master) {
      if (master) {
        if (this.isNew || production.new) {
          //取主数据的拆零或组装数量
          if (production.production_num > 0) {
            if (production.formulaSelected) {
              production.formulaSelected.formula_details.forEach(
                (formula_detail) => {
                  formula_detail.production_num =
                    this.$numberFormatter.formatTwoDot(
                      formula_detail.ratio * production.production_num
                    );
                }
              );
            } else {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  this.$numberFormatter.formatTwoDot(
                    formula_detail.ratio * production.production_num
                  );
              });
            }
          }
        } else if (this.mode == "edit" && !production.new) {
          if (this.production_plan.production_type == 1) {
            if (production.production_num > 0) {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  this.$numberFormatter.formatTwoDot(
                    formula_detail.ratio * production.production_num
                  );
              });
            }
          } else if (this.production_plan.production_type == 2) {
            if (production.production_num > 0) {
              production.formula_details.forEach((formula_detail) => {
                formula_detail.production_num =
                  this.$numberFormatter.formatTwoDot(
                    formula_detail.ratio * production.production_num
                  );
              });
            }
          }
        }
      } else {
        if (this.isNew) {
          //获取编辑的子数据计算主数据相应的数量
          let editDetail = production.formulaSelected.formula_details.find(
            (formula_detail) => formula_detail.material_id == material_id
          );
          production.production_num = this.$numberFormatter.formatTwoDot(
            editDetail.production_num / editDetail.ratio
          );
          //根据计算后的主数据数量计算子数据的数量
          production.formulaSelected.formula_details.forEach(
            (formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            }
          );
        } else if (this.mode == "edit") {
          if (this.production_plan.production_type == 1) {
            //获取编辑的子数据计算主数据相应的数量
            let editDetail = production.formula_details.find(
              (formula_detail) => formula_detail.material_id == material_id
            );
            production.production_num = this.$numberFormatter.formatTwoDot(
              editDetail.production_num / editDetail.ratio
            );
            //根据计算后的主数据数量计算子数据的数量
            production.formula_details.forEach((formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            });
          } else if (this.production_plan.production_type == 2) {
            //获取编辑的子数据计算主数据相应的数量
            let editDetail = production.formula_details.find(
              (formula_detail) => formula_detail.material_id == material_id
            );
            production.production_num = this.$numberFormatter.formatTwoDot(
              editDetail.production_num / editDetail.ratio
            );
            //根据计算后的主数据数量计算子数据的数量
            production.formula_details.forEach((formula_detail) => {
              formula_detail.production_num =
                this.$numberFormatter.formatTwoDot(
                  formula_detail.ratio * production.production_num
                );
            });
          }
        }
      }
    },
    // 移除某个商品
    removeDetail(productionMaterialDetail) {
      this.production_plan_details.splice(
        this.production_plan_details.findIndex(
          (detail) => detail.id == productionMaterialDetail.id
        ),
        1
      );
      this.production_materials.find((material) => {
        if (material.id == productionMaterialDetail.id) {
          material.disabled = false;
        }
      });
    },
    //处理提交数据
    submitData() {
      let production_plan_order = {};
      if (this.isNew) {
        production_plan_order = {
          stock_id: this.stock_id,
          production_type: this.production_plan.production_type,
          policy_type: 1,
          production_plan_history_details: [],
          memo: this.memo
        };
      } else if (this.mode == "edit") {
        production_plan_order = {
          id: this.production_plan.id,
          production_plan_history_details: [],
          memo: this.memo
        };
        if (this.action) {
          production_plan_order.status =
            this.action == "confirm" ? 2 : this.action == "approve" ? 3 : 0;
        }
      }

      if (this.stockOutNext) {
        production_plan_order.business_type = 2
      }

      if (!this.isFreeProduction) {
        // 非自由生产逻辑
        this.production_plan_details.forEach((detail) => {
          let history_detail = {};
          if (this.mode == "edit" && !detail.new) {
            if (!this.preview) {
              if (!detail.new) {
                history_detail = {
                  id: detail.id,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                };
              } else {
                history_detail = {
                  material_code: detail.material_code,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                  formula_code: this.preview
                      ? detail.formula_code
                      : detail.new
                          ? detail.formulaSelected.uuid
                          : detail.formula_code,
                };
              }
            } else {
              if (!detail.id) {
                history_detail = {
                  material_code: detail.material_code,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                  formula_code: this.preview
                      ? detail.formula_code
                      : detail.new
                          ? detail.formulaSelected.uuid
                          : detail.formula_code,
                };
              } else {
                history_detail = {
                  id: detail.id,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                };
              }
            }
          } else {
            history_detail = {
              material_code: detail.material_code,
              production_num: detail.production_num,
              memo: detail.memo,
              other_cost: detail.other_cost,
              formula_code: this.preview
                  ? detail.formula_code
                  : detail.new
                      ? detail.formulaSelected.uuid
                      : detail.formula_code,
            };
            if (this.autoGenerate) {
              history_detail.stock_in_details = this.preview
                  ? detail.stock_in_details
                  : detail.detail_ids;
            }
          }
          let formula_materials = [];

          if (this.production_plan.production_type == 2) {
            if (this.preview) {
              detail.formula_details.forEach((material) => {
                formula_materials.push({
                  material_id: material.material_id,
                  in_price: material.in_price,
                });
              });
            } else {
              if (detail.new) {
                detail.formulaSelected.formula_details.forEach((material) => {
                  formula_materials.push({
                    material_id: material.material_id,
                    in_price: material.in_price,
                  });
                });
              } else {
                detail.formula_details.forEach((material) => {
                  formula_materials.push({
                    material_id: material.material_id,
                    in_price: material.in_price,
                  });
                });
              }
            }

            history_detail.formula_details = formula_materials;
          }
          if (this.production_plan.production_type == 1) {
            history_detail.in_price = detail.in_price;
          }
          if (this.stockOutNext) {
            history_detail.out_detail_ids = detail.out_detail_ids
          }

          production_plan_order.production_plan_history_details.push(
              history_detail
          );
        });
      } else {
        // 自由生产逻辑
        production_plan_order.policy_type = 1
        production_plan_order.business_type = 3
        this.production_plan_details.forEach((detail) => {
          let history_detail = {};
          if (this.mode == "edit" && !detail.new) {
            if (!this.preview) {
              if (!detail.new) {
                history_detail = {
                  id: detail.id,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                };
              } else {
                history_detail = {
                  material_code: detail.material_code,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                  formula_code: this.preview
                      ? detail.formula_code
                      : detail.new
                          ? detail.formulaSelected.uuid
                          : detail.formula_code,
                };
              }
            } else {
              if (!detail.id) {
                history_detail = {
                  material_code: detail.material_code,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                  formula_code: this.preview
                      ? detail.formula_code
                      : detail.new
                          ? detail.formulaSelected.uuid
                          : detail.formula_code,
                };
              } else {
                history_detail = {
                  id: detail.id,
                  production_num: detail.production_num,
                  memo: detail.memo,
                  other_cost: detail.other_cost,
                };
              }
            }
          } else {
            history_detail = {
              material_code: detail.material_code,
              production_num: detail.production_num,
              memo: detail.memo,
              other_cost: detail.other_cost,
            };
            if (this.autoGenerate) {
              history_detail.stock_in_details = this.preview
                  ? detail.stock_in_details
                  : detail.detail_ids;
            }
          }
          let formula_materials = [];
          detail.formula_details.forEach((material) => {
            formula_materials.push({
              material_id: material.material_id,
              material_code: material.material_code,
              production_num: material.production_num,
              material_name: material.material_name,
              category_code: material.category_code,
              standard_detail_id: material.standard_detail_id,
              standard_name: material.standard_name,
              unit: material.unit,
            });
          });
          history_detail.formula_details = formula_materials;
          production_plan_order.production_plan_history_details.push(
              history_detail
          );
        });
      }

      return production_plan_order;
    },
    //提交预览
    doPreview() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (this.production_plan_details.length) {
              let submitData = this.submitData();
              if (this.isNew) {
                ProductionPlans.addPreview(submitData).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.production_plan = response.data.production_plan;
                      this.memo = response.data.production_plan.memo;
                      this.production_plan_details =
                        response.data.production_plan.production_plan_history_details;
                    }
                  }.bind(this)
                );
              } else if (this.mode == "edit") {
                ProductionPlans.editPreview(submitData).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.production_plan = response.data.production_plan;
                      this.memo = response.data.production_plan.memo;
                      this.production_plan_details =
                        response.data.production_plan.production_plan_history_details;
                    }
                  }.bind(this)
                );
              }
            } else {
              this.$snackbar.error(i18n.t("ProductionPlans.submitNullErrMassage"))
              // snackbar.error(i18n.t("ProductionPlans.submitNullErrMassage"));
            }
          }
        }.bind(this)
      );
    },
    //单据提交
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      let submitData = this.submitData();
      if (this.isNew) {
        ProductionPlans.add(submitData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/production-plans");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else if (this.mode == "edit") {
        ProductionPlans.edit(submitData)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/production-plans");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
    // 修改的组装拆零配方提交
    formulaSubmit(formula) {
      this.$store.dispatch("fullscreenLoading");
      var data = {};
      if (this.production_plan.production_type == 1) {
        data = {
          id: this.currentMaterial.id,
          combine_formula_json: formula,
        };
      } else if (this.production_plan.production_type == 2) {
        data = {
          id: this.currentMaterial.id,
          split_formula_json: formula,
        };
      }

      ProductionPlans.editMaterialFormula(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getProductionMaterialDetails(this.currentMaterial.id);
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    getProductionMaterialDetails(materialId) {
      ProductionPlans.getProductionMaterialDetails({
        stock_id: this.stock_id,
        production_type: this.production_plan.production_type,
        material_id: materialId,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var production_material = response.data.production_material;
            var formulaDetails = Object.values(production_material.formula);
            formulaDetails.forEach((formula) => {
              formula.formula_details.forEach((detail) => {
                detail.production_num = "";
                detail.in_price = 0;
              });
            });
            if (
              this.production_plan_details.findIndex(
                (detail) => detail.id == materialId
              ) > -1
            ) {
              var preDetailInfo = this.production_plan_details.find(
                (detail) => detail.id == materialId
              );
              this.production_plan_details.splice(
                this.production_plan_details.findIndex(
                  (detail) => detail.id == materialId
                ),
                1,
                Object.assign(production_material, {
                  new: this.production_plan_details.length + 1,
                  production_num: "",
                  formulaDetails: formulaDetails,
                  formulaSelected: preDetailInfo.formulaSelected
                    ? production_material.formula[
                        preDetailInfo.formulaSelected.uuid
                      ]
                    : production_material.formula[
                        production_material.formula_default_key
                      ],
                })
              );
            } else {
              this.production_plan_details.unshift(
                Object.assign(production_material, {
                  new: this.production_plan_details.length + 1,
                  production_num: "",
                  formulaDetails: formulaDetails,
                  formulaSelected:
                    production_material.formula[
                      production_material.formula_default_key
                    ],
                })
              );
            }
          }
        }.bind(this)
      );
      //设置商品select禁选项
      this.production_materials = this.production_materials.map((item) => {
        const disabled =
          this.productionMaterialSelected &&
          this.productionMaterialSelected.id == item.id
            ? true
            : item.disabled
            ? true
            : false;
        return Object.assign({}, item, { disabled });
      });

      this.productionMaterialSelected = {};
    },
    addFreeProductionDetails(material) {
      this.production_plan_details.unshift(
          Object.assign(material, {
            new: this.production_plan_details.length + 1,
            formula_details: [],
            production_num: "",
            formulaDetails: [],
            formulaSelected: [],
          })
      );
      this.productionMaterialSelected = {};
    },
    addFreeProduction(data, index) {
      if (this.freeProductionMaterialSelected) {
        this.production_plan_details[index].formula_details.push(this.freeProductionMaterialSelected)
      }
      this.freeProductionMaterialSelected = {}
    },
    productionMaterialItems(data) {
      let disableIds = []
      disableIds.push(data.id)
      data.formula_details.forEach((f) => {
        disableIds.push(f.id)
      });
      return this.production_materials.map((item) => {
        const disabled = (disableIds.find((d) => d == item.id) ) ? true : false;
        return Object.assign({}, item, { disabled });
      });
    },
    resetSearch() {
      this.shopsSelected = [];
      this.materialSelected = [];
      this.stockOutOptions = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.stockOutOptions = Object.assign({}, this.stockOutOptions, {});
    },
    getStockOutsFromAPI() {
      this.loading = true;
      let options = Object.assign({}, this.stockOutOptions, {
        itemsPerPage:
            (this.stockOutOptions && this.stockOutOptions.itemsPerPage == -1)
                ? this.$consts.limitAll
                : this.stockOutOptions.itemsPerPage,
      });
      StockOuts.fetch(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockOuts = response.data.stock_outs;
              this.stockOutPaging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.stockOutOptions.page = 1;
            }
            this.stockOutLoading = false;
          }.bind(this)
      );
    },
    checkStockOut() {
      if (this.stockOutSelected && this.stockOutSelected.length) {
        let postData = {
          stock_order_ids: this.stockOutSelected.map((stockOut) => {return stockOut.id}),
          is_stock_current: (this.isStockCurrent && this.isStockCurrent.length > 0) ? this.isStockCurrent : [0],
          stock_id: this.stockOutOptions.stock_ids[0],
          material_ids: this.stockOutOptions.material_ids,
          production_type: this.production_plan.production_type,
        }
        ProductionPlans.getProducibleDetailsByStockOut(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              response.data.production_materials.map((item, materialId) => {
                let production_material = item;
                let formulaDetails = Object.values(production_material.formula);
                formulaDetails.forEach((formula) => {
                  formula.formula_details.forEach((detail) => {
                    detail.production_num = "";
                    detail.in_price = 0;
                  });
                });
                if (
                    this.production_plan_details.findIndex(
                        (detail) => detail.id == materialId
                    ) > -1
                ) {
                  var preDetailInfo = this.production_plan_details.find(
                      (detail) => detail.id == materialId
                  );
                  this.production_plan_details.splice(
                      this.production_plan_details.findIndex(
                          (detail) => detail.id == materialId
                      ),
                      1,
                      Object.assign(production_material, {
                        new: this.production_plan_details.length + 1,
                        // production_num: "",
                        formulaDetails: formulaDetails,
                        formulaSelected: preDetailInfo.formulaSelected
                            ? production_material.formula[
                                preDetailInfo.formulaSelected.uuid
                                ]
                            : production_material.formula[
                                production_material.formula_default_key
                                ],
                      })
                  );
                } else {
                  this.production_plan_details.unshift(
                      Object.assign(production_material, {
                        new: this.production_plan_details.length + 1,
                        // production_num: "",
                        formulaDetails: formulaDetails,
                        formulaSelected:
                            production_material.formula[
                                production_material.formula_default_key
                                ],
                      })
                  );
                }
                this.updateProductionNum(item.id, item,true)
              });
              this.stockOutSelect = false;
              this.stockOutNext = true;
            }
          }.bind(this)
        );
      }else {
        this.$snackbar.error(i18n.t("ProductionPlans.chooseStockOutsHint"));
      }
    }
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.production_plan = {
            production_type: 2,
          };
        } else if (this.$route.params.id) {
          this.getProductionPlanFromAPI();
        }
      },
    },
    production_plan: {
      deep: true,
      handler() {
        if (this.production_plan) {
          if (!this.isFreeProduction) {
            this.getProductionMaterialsFromAPI();
          }
        }
      },
    },
    next: {
      handler() {
        if (this.next) {
          if (this.isFreeProduction) {
            this.getStockMaterialsFromAPI()
          } else {
            this.getProductionMaterialsFromAPI();
          }
        } else {
          this.production_plan_details = [];
          this.production_materials = [];
          this.productionMaterialSelected = [];
        }
      },
    },
    productionMaterialSelected: {
      deep: true,
      handler() {
        if (
          this.productionMaterialSelected &&
          this.productionMaterialSelected.id
        ) {
          if (this.isFreeProduction) {
            this.addFreeProductionDetails(this.productionMaterialSelected)
          } else {
            this.getProductionMaterialDetails(this.productionMaterialSelected.id);
          }
        }
      },
    },
    production_plan_details: {
      deep: true,
      handler() {},
    },
    stockOutOptions: {
      deep: true,
      handler() {
        this.stockOutSelected = [];
        this.getStockOutsFromAPI();
      },
    },
    stockSelected: {
      handler() {
        this.stockOutOptions.stock_ids = this.stockSelected
            ? [this.stockSelected.id]
            : [];
      },
    },
    shopsSelected: {
      handler() {
        this.stockOutOptions.shop_ids = this.shopsSelected
            ? this.shopsSelected.map((shop) => {
              return shop.id;
            })
            : [];
      },
    },
    materialSelected: {
      handler() {
        this.stockOutOptions.material_ids = this.materialSelected
            ? this.materialSelected.map((e) => {
              return e.id;
            })
            : [];
      },
    },
  },
};
</script>